import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const isAuthenticated = this.authenticationService.isUserAuthenticated();
    if (isAuthenticated) {

        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.authenticationService.getAccessToken()}`
          },
        });
      
    }

    return next.handle(request).pipe(
      catchError((err: any) => {
        let { status, statusText, error } = err;

        if ((401 == status && "ERR_INVALID_SESSION" == error) ) {
          this.authenticationService.logout(); // Session expired
        }

        throw err;
      })
    );

  }

}
